import {
  Input, SimpleChanges, OnChanges,
  Component,
  OnInit
} from '@angular/core';
import {CompanyService} from "../../services/company-service/company-service";
import {OrderBagItemDetailVM} from "../../models/OrderBagItemVM.model";
import {ServantService} from "../../services/servant-service/servant-service";
import {TestService} from "../../services/test-services/test.service";
import {CompanyVM} from "../../models/CompanyVM.model";
import {InvoiceInfoService} from "../../services/invoice-info-service/invoice-info.service";
import {OrderBagService} from "../../services/orderbag/orderbag.service";


@Component({

  selector: 'rw-test-return-url',  // <home></home>
  // providers: [TestService],
  // styles: [require('./test-return-url.component.css')],
  template: require('./test-return-url.component.html')

})
export class TestReturnUrlComponent implements OnInit, OnChanges {


  constructor(
  ) {
  }

  public ngOnInit() {

    this.extractPostData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    let parent = this;
  }

  extractPostData() {
    let refId ;
    const urlParams = new URLSearchParams(window.location.search);
    debugger;
    refId = urlParams.get('RefId');
  }


}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/test-services/test-return-url.component.ts